:host {
  display: block;

  .dialog-content {
    margin: 32px;
    text-align: center;

    sy-text[type='h4'] {
      margin-bottom: 4px;
    }

    sy-text[type='body'] {
      color: #495057;
    }
  }
}
